import Dispatcher from '../../dispatcher';
import HttpRequestConstants from '../../constants/http_request';

function shippingFeesStarted() {
  Dispatcher.handleHttpRequestAction({
    type: HttpRequestConstants.SHIPPING_FEES_STARTED,
  });
}

function shippingFeesSuccess() {
  Dispatcher.handleHttpRequestAction({
    type: HttpRequestConstants.SHIPPING_FEES_SUCCESS,
  });
}

function shippingFeesFailed() {
  Dispatcher.handleHttpRequestAction({
    type: HttpRequestConstants.SHIPPING_FEES_FAILED,
  });
}

function shippingAdFeesStarted() {
  Dispatcher.handleHttpRequestAction({
    type: HttpRequestConstants.SHIPPING_AD_FEES_STARTED,
  });
}

function shippingAdFeesSuccess() {
  Dispatcher.handleHttpRequestAction({
    type: HttpRequestConstants.SHIPPING_AD_FEES_SUCCESS,
  });
}

function shippingAdFeesFailed() {
  Dispatcher.handleHttpRequestAction({
    type: HttpRequestConstants.SHIPPING_AD_FEES_FAILED,
  });
}

export {
  shippingFeesStarted,
  shippingFeesSuccess,
  shippingFeesFailed,
  shippingAdFeesStarted,
  shippingAdFeesSuccess,
  shippingAdFeesFailed,
};
